import * as Types from '@saas/interfaces/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchedQualificationFragment = (
  { __typename?: 'Qualification' }
  & Pick<Types.Qualification, 'id' | 'objectId' | 'name'>
);

export type GetQualificationFromLabelQueryVariables = Types.Exact<{
  qualificationLabel: Types.Scalars['String']['input'];
}>;


export type GetQualificationFromLabelQuery = (
  { __typename?: 'Query' }
  & { qualifications: (
    { __typename?: 'QualificationConnection' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'QualificationEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'Qualification' }
        & Pick<Types.Qualification, 'id' | 'objectId' | 'name'>
      )> }
    )>>> }
  ) }
);

export const FetchedQualificationFragmentDoc = gql`
    fragment FetchedQualification on Qualification {
  id
  objectId
  name
}
    `;
export const GetQualificationFromLabelDocument = gql`
    query getQualificationFromLabel($qualificationLabel: String!) {
  qualifications(where: {name: {equalTo: $qualificationLabel}}, first: 1) {
    edges {
      node {
        ...FetchedQualification
      }
    }
  }
}
    ${FetchedQualificationFragmentDoc}`;

/**
 * __useGetQualificationFromLabelQuery__
 *
 * To run a query within a React component, call `useGetQualificationFromLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualificationFromLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualificationFromLabelQuery({
 *   variables: {
 *      qualificationLabel: // value for 'qualificationLabel'
 *   },
 * });
 */
export function useGetQualificationFromLabelQuery(baseOptions: Apollo.QueryHookOptions<GetQualificationFromLabelQuery, GetQualificationFromLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQualificationFromLabelQuery, GetQualificationFromLabelQueryVariables>(GetQualificationFromLabelDocument, options);
      }
export function useGetQualificationFromLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQualificationFromLabelQuery, GetQualificationFromLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQualificationFromLabelQuery, GetQualificationFromLabelQueryVariables>(GetQualificationFromLabelDocument, options);
        }
export type GetQualificationFromLabelQueryHookResult = ReturnType<typeof useGetQualificationFromLabelQuery>;
export type GetQualificationFromLabelLazyQueryHookResult = ReturnType<typeof useGetQualificationFromLabelLazyQuery>;
export type GetQualificationFromLabelQueryResult = Apollo.QueryResult<GetQualificationFromLabelQuery, GetQualificationFromLabelQueryVariables>;